var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentDatabaseLockFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11c0 2.21 3.58 4 8 4 1.053 0 2.059-.102 2.98-.286 1.028-1.568 3.025-2.63 5.02-2.714V8c0 2.21-3.58 4-8 4s-8-1.79-8-4v3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18c0-.39.037-.771.108-1.14A15.72 15.72 0 0111 17c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4 .794 0 1.562-.058 2.286-.166A5.999 5.999 0 0113 18zm6-12c0-2.21-3.58-4-8-4S3 3.79 3 6s3.58 4 8 4 8-1.79 8-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 16a2 2 0 10-4 0v1h-.25c-.413 0-.75.318-.75.714v3.572c0 .394.336.714.75.714h4.5c.414 0 .75-.32.75-.714v-3.572c0-.394-.336-.714-.75-.714H21v-1zm-3 1v-1a1 1 0 112 0v1h-2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDatabaseLockFill);
export default __webpack_public_path__ + "c68707ef7e46ca266465fb012118a270.svg";
export { ForwardRef as ReactComponent };